module.exports = __webpack_public_path__ + "img/portraits_13_V.d993b652.webp";